module.exports = __webpack_public_path__ + "assets/img/9.4ceef68c.png";